import React, { useState, useEffect, useRef } from "react";
import { Div, Modal, Icon, Button, Image, Anchor } from "atomize";
import Swiper from "react-id-swiper";
import PrimaryButton from "../components/common/PrimaryButton";
import { set } from "lodash";
import { Link } from "gatsby";
import {
  getUTMcookie,
  addUtmToUrl,
  addUtmInputValues,
} from "../utilities/helpers";
import {
  Player,
  ControlBar,
  CurrentTimeDisplay,
  TimeDivider,
  VolumeMenuButton,
} from "video-react";

const creatorImages = [
  "https://s3-alpha-sig.figma.com/img/08b2/3384/a417a638729f1e10b1d6a141de14801e?Expires=1600646400&Signature=E3LOEyewHFe9d8FdTR~ylwgjP6FrDeG-oCcOtlIBZ3j9WfcmfcaihsB9aiY9sCZea8Awls9nxGk9Eh8ddoqxubp81x9xgsSbRpDR3K2bHRGlk6B3d~tS8xsK63TYeKvwM-B2UO7A~SbywSeShGIkBX00lEYUO5~4HzQ59WetoScvNZ3GdsNddw1E0b8i4hsIGE-BVkNRNRK1scNrCzWcXVsdRbUidRq1Gm2hraajd-YuPGtmmZjg4L41Kgccq02JOChjxsL9GN~fx1uwwmGVnmbx7WHMVUa6~SC3bVTlwJCpZt5MVj-MwMIQuS~MaR1miI32bz57ysfz93cFyCFzZg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  "https://s3-alpha-sig.figma.com/img/75cd/d8bb/da742128471fe7727a10039379672494?Expires=1600646400&Signature=Oz0l-IONV2-zwEbcA5NksOdjO8Fwp26AWKgbVHh7Hg3mZq~TDKytAuFY8fIk0tPgqG6OMgLXnZTvLnqxdpYHThGLta~SBOEPthzcDjv8Oda32niDM3PqSNMH9hM~W9eOhvqRSHb5Oud0Shfgi1u14AImN2gzDbZzTgb-s3U561oV~EyXia14Ru7zlsPqZqlIiY8-ykohLDtMHjINpnw11lsyn957PsE81XTVb05VRhqEIWa3EdlnCEn5tGOU6PQVNw4vhOgW1~NuKlXGChPPTLvGTNs9oFVSecD5EtISpnuYsNjUxVXEKPKhuzkO-OX4hQZi1vanvqAGt4LThYdlBg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  "https://s3-alpha-sig.figma.com/img/e485/8bd6/c232cb61ffb4458305066bdf6ff739d1?Expires=1600646400&Signature=HUKGLAqpUCYvhuas3lp~iLft1GEPZoV82dXh0EYHxmI2Ae3ac6Rg4VWBJCnIDk14BVe-sVLrkeD5XGlnM9gJonQ9qS834d7VvLwWIpFFH-Vbc~FhaW9b0~TBLPhVqqzUqW0V4CyA~3SGvQDFNm27vxQ75r~N0uYj1lvuCJT~arIdM-hY-O2n6ll6tprIpre6Avo8e942v-33v5iDYo2hOQuJ3MFTI3LTnB-cKQmGiO3mdDdaLHFHQtrOUZplB7mvhAzNQOPCpbyoanBYZIlcG1fHgG2KdbNJaKm1ajiZrHYxqXNi6HpzJtBFaIuvbgK46gVJwp1gpwbvpn1tsUjxuQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  "https://s3-alpha-sig.figma.com/img/b815/4f13/0d54a92bfbd809211ecd998da66de2a1?Expires=1600646400&Signature=TahKsRflW1yBrxVmGziwMqvXX2XDbPq0rvBrOCaVdbQCPZI2wIdwRUSq1~tPn76q5rW0vth345kip1yDyemiXaUkJMMzMKreoUGBqLjLZ4tjXZwghEKnvWv6x-P~KaSRmWIwfzowp~HVXyfU4ge38MHsk2TPalHgUNcQWXli0v0HRun~CGZsD14PH9Kfli3zM4EUdTIxp5rdBYMoujhuX-wo1m9XNjxwmXUJEuljUDgNyPEb23A8bwBW12dI7A6VM8Sbre~h6x0h40ueAz~rpxcAVoanyPkD5xa1wcw4iiVbfbAVi1OobTVL8r9LpMW~FUFfN2Mp91lRDmHHTubuNg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
];

// const creatorGallery = [
//   {
//     type: "image",
//     source:
//       "https://s3-alpha-sig.figma.com/img/08b2/3384/a417a638729f1e10b1d6a141de14801e?Expires=1600646400&Signature=E3LOEyewHFe9d8FdTR~ylwgjP6FrDeG-oCcOtlIBZ3j9WfcmfcaihsB9aiY9sCZea8Awls9nxGk9Eh8ddoqxubp81x9xgsSbRpDR3K2bHRGlk6B3d~tS8xsK63TYeKvwM-B2UO7A~SbywSeShGIkBX00lEYUO5~4HzQ59WetoScvNZ3GdsNddw1E0b8i4hsIGE-BVkNRNRK1scNrCzWcXVsdRbUidRq1Gm2hraajd-YuPGtmmZjg4L41Kgccq02JOChjxsL9GN~fx1uwwmGVnmbx7WHMVUa6~SC3bVTlwJCpZt5MVj-MwMIQuS~MaR1miI32bz57ysfz93cFyCFzZg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
//   },
//   {
//     type: "image",
//     source:
//       "https://s3-alpha-sig.figma.com/img/75cd/d8bb/da742128471fe7727a10039379672494?Expires=1600646400&Signature=Oz0l-IONV2-zwEbcA5NksOdjO8Fwp26AWKgbVHh7Hg3mZq~TDKytAuFY8fIk0tPgqG6OMgLXnZTvLnqxdpYHThGLta~SBOEPthzcDjv8Oda32niDM3PqSNMH9hM~W9eOhvqRSHb5Oud0Shfgi1u14AImN2gzDbZzTgb-s3U561oV~EyXia14Ru7zlsPqZqlIiY8-ykohLDtMHjINpnw11lsyn957PsE81XTVb05VRhqEIWa3EdlnCEn5tGOU6PQVNw4vhOgW1~NuKlXGChPPTLvGTNs9oFVSecD5EtISpnuYsNjUxVXEKPKhuzkO-OX4hQZi1vanvqAGt4LThYdlBg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
//   },
//   {
//     type: "image",
//     source:
//       "https://s3-alpha-sig.figma.com/img/e485/8bd6/c232cb61ffb4458305066bdf6ff739d1?Expires=1600646400&Signature=HUKGLAqpUCYvhuas3lp~iLft1GEPZoV82dXh0EYHxmI2Ae3ac6Rg4VWBJCnIDk14BVe-sVLrkeD5XGlnM9gJonQ9qS834d7VvLwWIpFFH-Vbc~FhaW9b0~TBLPhVqqzUqW0V4CyA~3SGvQDFNm27vxQ75r~N0uYj1lvuCJT~arIdM-hY-O2n6ll6tprIpre6Avo8e942v-33v5iDYo2hOQuJ3MFTI3LTnB-cKQmGiO3mdDdaLHFHQtrOUZplB7mvhAzNQOPCpbyoanBYZIlcG1fHgG2KdbNJaKm1ajiZrHYxqXNi6HpzJtBFaIuvbgK46gVJwp1gpwbvpn1tsUjxuQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
//   },
//   {
//     type: "video",
//     thumb:
//       "https://s3-alpha-sig.figma.com/img/b815/4f13/0d54a92bfbd809211ecd998da66de2a1?Expires=1600646400&Signature=TahKsRflW1yBrxVmGziwMqvXX2XDbPq0rvBrOCaVdbQCPZI2wIdwRUSq1~tPn76q5rW0vth345kip1yDyemiXaUkJMMzMKreoUGBqLjLZ4tjXZwghEKnvWv6x-P~KaSRmWIwfzowp~HVXyfU4ge38MHsk2TPalHgUNcQWXli0v0HRun~CGZsD14PH9Kfli3zM4EUdTIxp5rdBYMoujhuX-wo1m9XNjxwmXUJEuljUDgNyPEb23A8bwBW12dI7A6VM8Sbre~h6x0h40ueAz~rpxcAVoanyPkD5xa1wcw4iiVbfbAVi1OobTVL8r9LpMW~FUFfN2Mp91lRDmHHTubuNg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
//     source: "http://techslides.com/demos/sample-videos/small.mp4",
//   },
// ];

const videoParams = {
  fluid: false,
  playsInline: true,
  autoPlay: false,
  isFullscreen: true,
};

const HomeCreatorModal = ({
  isOpen,
  onClose,
  modalContent,
  swiperIndex,
  showBrand,
}) => {
  const [activeImage, setActiveImage] = useState(0);
  const [creatorSwiper, updateCreatorSwiper] = useState(null);
  const videoPlayer = useRef();

  const params = {
    slidesPerView: 1,
    getSwiper: updateCreatorSwiper,
    loop: true,
    effect: "fade",
    speed: 600,
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
  };

  const goNext = () => {
    if (creatorSwiper !== null) {
      creatorSwiper.slideNext();
    }
  };

  const goPrev = () => {
    if (creatorSwiper !== null) {
      creatorSwiper.slidePrev();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      rounded={{ xs: "0", md: "10px" }}
      maxW={{ md: "45rem", xs: "100%" }}
      p="0"
      align={{ xs: "flex-start", md: "center" }}
      className="creator-modal"
    >
      <Div className="close-wrapper">
        <Icon
          className="close-icon"
          name="Cross"
          size="40px"
          pos={{ xs: "relative", md: "fixed" }}
          top={{ xs: "auto", md: "2rem" }}
          right={{ xs: "auto", md: "2rem" }}
          onClick={onClose}
          zIndex="200"
          cursor="pointer"
        />
      </Div>
      <Div>
        <Swiper {...params} initialSlide={swiperIndex}>
          {modalContent.map(creatorInfo => {
            return (
              <Div p={{ xs: "20px 35px 60px", lg: "30px 60px" }}>
                <Div className="creator-head">
                  <Div className="creator-namebox">
                    <Div className="creator-name">{creatorInfo.name}</Div>
                    <Div className="creator-location">
                      {creatorInfo.location}
                    </Div>
                  </Div>
                  <Div className="creator-count">
                    <Div className="count">
                      {creatorInfo.instagramFollowers}
                    </Div>
                    <Div className="sub-text">Instagram Followers</Div>
                  </Div>
                </Div>
                <Div className="creator-gallery">
                  <Div className="creator-thumbnails">
                    {creatorInfo.gallery.map((image, index) => {
                      return (
                        <Div
                          className={`thumbnail-item ${activeImage === index &&
                            "active"}`}
                          bgImg={
                            image.type === "video" ? image.thumb : image.source
                          }
                          onClick={() => setActiveImage(index)}
                        />
                      );
                    })}
                    <Div className="border"></Div>
                  </Div>
                  {creatorInfo.gallery[activeImage].type === "video" ? (
                    <Div>
                      <Player
                        {...videoParams}
                        ref={videoPlayer}
                        poster={creatorInfo.gallery[activeImage].thumb}
                        className="video-modal"
                      >
                        <source src={creatorInfo.gallery[activeImage].source} />

                        <ControlBar>
                          <CurrentTimeDisplay order={4.1} />
                          <TimeDivider order={4.2} />
                          <VolumeMenuButton order={8} />
                        </ControlBar>
                      </Player>
                    </Div>
                  ) : (
                    <Div
                      className="creator-image"
                      bgImg={creatorInfo.gallery[activeImage].source}
                      p={{ b: "97.5%" }}
                    />
                  )}
                  {/* <Div
                    className="creator-image"
                    bgImg={creatorInfo.gallery[activeImage].source}
                    p={{ b: "97.5%" }}
                  /> */}
                </Div>
                <Div className="creator-count-mobile">
                  <Div className="count">{creatorInfo.instagramFollowers}</Div>
                  <Div className="sub-text">Instagram Followers</Div>
                </Div>
                <Div className="creator-content">
                  <Div className="creator-text">{creatorInfo.text}</Div>
                  <Div className="creator-action-wrapper">
                    <PrimaryButton
                      tag="div"
                      className="primary-btn work-with-me-btn"
                      bg="primary"
                      hoverBg="primary700"
                      textColor="black"
                      textTransform="none"
                      border="none"
                      w="100%"
                      // onClick={() => showBrand(true)}

                      onClick={() => {
                        const tags = getUTMcookie();
                        const url = addUtmToUrl(
                          "https://app.trend.io/signup",
                          tags
                        );
                        window.location.href = url;

                        // console.log({ url });
                      }}
                    >
                      <Image
                        src="../images/check-circle.svg"
                        h="1.25rem"
                        m={{ r: "0.5rem" }}
                      />
                      <Div>{creatorInfo.actionBtn.text}</Div>
                    </PrimaryButton>
                    <Div className="help-text">
                      {creatorInfo.secondaryAction.text}
                      <Link
                        className="link"
                        to={creatorInfo.secondaryAction.link}
                      >
                        {creatorInfo.secondaryAction.linkText}
                      </Link>
                    </Div>
                  </Div>
                </Div>
              </Div>
            );
          })}
        </Swiper>
        <Div className="swiper-nav-btn next" onClick={() => goNext()}>
          <Icon name="RightArrow" color="white" size="40px" />
        </Div>
        <Div className="swiper-nav-btn prev" onClick={() => goPrev()}>
          <Icon name="LeftArrow" color="white" size="40px" />
        </Div>
      </Div>
    </Modal>
  );
};
export default HomeCreatorModal;
